import { render, staticRenderFns } from "./SliderNav.vue?vue&type=template&id=79684c7b"
import script from "./SliderNav.vue?vue&type=script&lang=js"
export * from "./SliderNav.vue?vue&type=script&lang=js"
import style0 from "./SliderNav.vue?vue&type=style&index=0&id=79684c7b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports